import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';
import ConditionedStock from './ConditionedStock';

const ConditionedStockPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('stocks.global.title')}>
      <ConditionedStock />
    </PageContent>
  );
};
export default ConditionedStockPage;
